import * as LWP from "VSS/LWP";
import { IVssContributionService } from "VSS/Platform/Contribution";

export interface LegacyProjectInformation {
    ProjectUsesKnownBugCategoryName: boolean;
}

/** Encapsulates contributed page service for legacy information about current Project.
 *  Drives compatability behaviors in widget rendering and configuration.  */
export class LegacyProjectDataHelper {
    public static getResults(): LegacyProjectInformation {
        const defaultLegacyProjectInformation = { ProjectUsesKnownBugCategoryName: false };

        const contributionService: IVssContributionService | undefined = LWP.getLWPService("IVssContributionService");
        if (contributionService != null) {
            const result: { value: LegacyProjectInformation } | undefined = contributionService.getData(
                "ms.vss-dashboards-web.legacy-project-data-provider"
            );
            return result ? result.value : defaultLegacyProjectInformation;
        } else {
            return defaultLegacyProjectInformation;
        }
    }
}
